import { useState } from "react";
import { http, formatError } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Envelope, InstagramLogo, MapPin } from "@phosphor-icons/react";
import PageSEO from "@/components/PageSEO";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await http.post("/contact", form);
      toast.success(data?.message || "Message received.");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) { toast.error(formatError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <PageSEO
        title="Contact Mayoto"
        description="Get in touch with Mayoto. Reach us on mayotonexo@gmail.com or via Instagram @mayoto for enquiries about investments, partnerships and support."
        canonicalPath="/contact"
      />
      <section className="mayo-grain">
        <div className="container-wide py-20 lg:py-24">
          <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs">CONTACT MAYOTO</p>
          <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a1128] max-w-3xl" data-testid="contact-title">
            Let's talk.
          </h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container-wide grid lg:grid-cols-3 gap-10">
          <div className="lg:col-span-1 space-y-6">
            <div className="rounded-2xl bg-[#0a1128] text-white p-8">
              <p className="font-display font-black text-2xl">MAYOTO</p>
              <p className="mt-1 text-[#d4af37] font-display font-bold tracking-widest text-xs">NIGERIA</p>
              <div className="mt-6 space-y-4 text-sm">
                <div className="flex items-start gap-3"><Envelope size={20} className="text-[#00b4d8] mt-0.5" /><div><p className="text-slate-400">Email</p><a href="mailto:mayotonexo@gmail.com" className="hover:text-[#00b4d8]">mayotonexo@gmail.com</a></div></div>
                <div className="flex items-start gap-3"><InstagramLogo size={20} className="text-[#00b4d8] mt-0.5" /><div><p className="text-slate-400">Instagram</p><a href="https://instagram.com/mayoto" target="_blank" rel="noreferrer" className="hover:text-[#00b4d8]">@mayoto</a></div></div>
                <div className="flex items-start gap-3"><MapPin size={20} className="text-[#00b4d8] mt-0.5" /><div><p className="text-slate-400">Location</p><p>Nigeria</p></div></div>
              </div>
            </div>
          </div>

          <form onSubmit={submit} className="lg:col-span-2 bg-white border border-slate-200 rounded-3xl p-8 grid sm:grid-cols-2 gap-5" data-testid="contact-form">
            <div><Label>Name</Label><Input required value={form.name} onChange={e => set("name", e.target.value)} data-testid="contact-name" /></div>
            <div><Label>Email</Label><Input required type="email" value={form.email} onChange={e => set("email", e.target.value)} data-testid="contact-email" /></div>
            <div><Label>Phone</Label><Input value={form.phone} onChange={e => set("phone", e.target.value)} data-testid="contact-phone" /></div>
            <div><Label>Subject</Label><Input required value={form.subject} onChange={e => set("subject", e.target.value)} data-testid="contact-subject" /></div>
            <div className="sm:col-span-2"><Label>Message</Label><Textarea required rows={6} value={form.message} onChange={e => set("message", e.target.value)} data-testid="contact-message" /></div>
            <div className="sm:col-span-2">
              <Button type="submit" disabled={loading} className="btn-shine bg-[#00b4d8] hover:bg-[#0096c7] rounded-full px-7 py-6 text-base w-full sm:w-auto" data-testid="contact-submit">
                {loading ? "Sending…" : "Send Message"}
              </Button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}
